import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import client from "../../components/contentful/Contentful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import MainLayout from "../../components/MainLayout/MainLayout";
import Head from "next/head";
import { mapTargetSiteToURL } from "../glossary/index";
import { WINNING_METRICS } from "../../components/WinningMetrics";
const WinningMetricDetails = () => {
  const router = useRouter();
  const winningMetricDetail = router.query?.WinningMetricDetails;
  const metricDetails = WINNING_METRICS.find(
    (metric) => metric.name.toLowerCase() === winningMetricDetail.toLowerCase()
  );

  if (!metricDetails) {
    return (
      <MainLayout>
        <p>Loading...</p>
      </MainLayout>
    );
  }

  return (
    <>
      <Head>
        <title>{`${metricDetails.name} | ShotQualityBets Glossary`}</title>
        <meta name="description" content={`Learn more about ${metricDetails.name}.`} key="description" />
      </Head>
      <MainLayout>
        <div className="pt-5 p-4 container-fluid bg-white">
          <div className="row">
            <div className="col-12 mb-4">
              <p>
                <Link className="is-link" href="/glossary">
                  Winning Metrics{" "}
                </Link>{" "}
                &gt;
                <span className="color-orange"> {metricDetails.name}</span>
              </p>
            </div>
            <div className="col-md-8 ">
              <h1 className="color-orange fw-6 text-xxl">{metricDetails.name}</h1>
              <div className="mb-5">
                <h5 className=""> Definition:</h5>
                <p style={{ whiteSpace: "pre-line" }}>{metricDetails.definition}</p>
              </div>

              {metricDetails?.longDefinition && (
                <div className="mb-5">
                  <h5 className=""> Long Definition:</h5>
                  <p style={{ whiteSpace: "pre-line" }}>{metricDetails?.longDefinition} </p>
                </div>
              )}
              {/* {metricDetails.fields.targetPage && (
                  <p>
                    <strong>See {metricDetails.name} On:</strong>{" "}
                    {metricDetails.fields.targetPage.map((site) => (
                      <Link className="glossary-target-page" target="_blank" href={mapTargetSiteToURL(site)} key={site}>
                        {site}
                        {metricDetails.fields.targetPage[metricDetails.fields.targetPage.length - 1] === site
                          ? " "
                          : ", "}
                      </Link>
                    ))}
                  </p>
                )} */}
            </div>
            <div className="col-md-4 overflow-auto box-shadow-1 p-4 scrollbar-none" style={{ height: "150vh" }}>
              <h4 className="text-center color-orange mb-4">More Winning Metrics</h4>
              {WINNING_METRICS.map(
                (metric, index) =>
                  metric && (
                    <Link key={index} className="is-link" href={`/glossary/` + encodeURIComponent(metric.name)}>
                      <div className="card glossary-card text-center p-4 mb-4 border-radius-10">
                        <h3>{metric.name}</h3>
                        <div style={{ whiteSpace: "pre-line" }}>{metric.definition}</div>
                        {/* {metric.fields.targetSite && metric.fields.targetPage && (
                            <p>
                              <strong>Used On: </strong>
                              {metric.fields.targetPage.map((site) => (
                                <Link
                                  className="glossary-target-page"
                                  target="_blank"
                                  href={mapTargetSiteToURL(site)}
                                  key={site}
                                >
                                  {site}
                                  {metric.fields.targetPage[metric.fields.targetPage.length - 1] === site ? " " : ", "}
                                </Link>
                              ))}
                            </p>
                          )} */}
                      </div>
                    </Link>
                  )
              )}
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default WinningMetricDetails;
